export default __webpack_public_path__ + "static/media/guest_18_01.28dc5281.png";